import { render } from "./TestSystemBadge.vue?vue&type=template&id=36a47866&scoped=true"
import script from "./TestSystemBadge.vue?vue&type=script&lang=js"
export * from "./TestSystemBadge.vue?vue&type=script&lang=js"

import "./TestSystemBadge.vue?vue&type=style&index=0&id=36a47866&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a47866"]])

export default __exports__